var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrown1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frown",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9999",
    "data-name": "Path 9999",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8Zm8.065,16.935a3.226,3.226,0,1,1-3.226,3.226A3.226,3.226,0,0,1,33.065,24.935Zm-16.129,0a3.226,3.226,0,1,1-3.226,3.226A3.226,3.226,0,0,1,16.935,24.935Zm17.157,22a11.845,11.845,0,0,0-18.185,0,1.614,1.614,0,0,1-2.48-2.067,15.054,15.054,0,0,1,23.135.01A1.607,1.607,0,0,1,34.093,46.931Z",
    fill: "#ff8066",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10000",
    "data-name": "Path 10000",
    d: "M139.226,176a3.226,3.226,0,1,0,3.226,3.226A3.226,3.226,0,0,0,139.226,176Zm16.129,0a3.226,3.226,0,1,0,3.226,3.226A3.226,3.226,0,0,0,155.355,176Z",
    transform: "translate(-122.29 -151.065)",
    fill: "#ff8066"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrown1);
export default __webpack_public_path__ + "static/media/frown-1.24655a2daf09d46062f4b30ab895c6da.svg";
export { ForwardRef as ReactComponent };